"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingExperienceQuestionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FalconSelectQuestionWidgetBase_1 = require("../../FalconSelectQuestionWidgetBase");
var DrivingExperienceQuestionWidget = /** @class */ (function (_super) {
    __extends(DrivingExperienceQuestionWidget, _super);
    function DrivingExperienceQuestionWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderInputField = function () {
            var _a;
            return ((0, jsx_runtime_1.jsx)("div", { className: "input-group", children: (0, jsx_runtime_1.jsxs)("select", { id: _this.props.question.name, className: "form-control ".concat(_this.getInputValidationClass()), onChange: _this.handleOnChangeEvent, onFocus: _this.executeNativeEvent, onBlur: _this.handleOnBlurEvent, onClick: _this.executeNativeEvent, onDoubleClick: _this.executeNativeEvent, disabled: _this.getSetting(DrivingExperienceQuestionWidget.inputDisabledSetting, false) ||
                        _this.isReadOnly(), value: _this.getValue(), children: [(0, jsx_runtime_1.jsx)("option", { value: "", disabled: true, children: _this.props.question.placeHolder ? _this.props.question.placeHolder : "Please select..." }), (_a = _this.state.lookupValues) === null || _a === void 0 ? void 0 : _a.map(function (lookupItem) {
                            var className = lookupItem.value.replace(/ /g, "_").toLocaleLowerCase();
                            return ((0, jsx_runtime_1.jsx)("option", { className: className, value: lookupItem.id, children: _this.renderHtml(lookupItem.value) }, lookupItem.id));
                        })] }) }));
        };
        _this.getValue = function () {
            var interactionFieldValue = _this.bindFromField(_this.props.question.interactionField);
            if (interactionFieldValue === undefined || interactionFieldValue === null) {
                return "";
            }
            return interactionFieldValue;
        };
        _this.handleOnChangeEvent = function (event) {
            (function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.validateInternal(event.target.value)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); })();
            _super.prototype.handleOnChangeEvent.call(_this, event);
        };
        _this.handleOnBlurEvent = function (event) {
            var _a, _b, _c, _d, _e;
            var valueAsString = String((_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "");
            event.target.value = valueAsString;
            var driverIndex = _this.getSetting("driverIndex", _this.props.question.settings);
            if (driverIndex !== undefined && ((_c = _this.props.interaction.additionalDrivers) === null || _c === void 0 ? void 0 : _c[driverIndex])) {
                _this.props.interaction.additionalDrivers[driverIndex].drivingExperience = valueAsString;
            }
            else if ((_e = (_d = _this.props) === null || _d === void 0 ? void 0 : _d.interaction) === null || _e === void 0 ? void 0 : _e.policyHolder) {
                _this.props.interaction.policyHolder.drivingExperience = valueAsString;
            }
            _super.prototype.handleOnBlurEvent.call(_this, event);
        };
        _this.renderLicenceChangeHeadsUpPopup = function () {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "licence-experience-info-panel banner banner-info", children: ["Heads up - ", (0, jsx_runtime_1.jsx)("strong", { children: "If you have changed your EU Licence to a UK Licence" }), " and DIDN'T have to take a UK Driving Test, you can", " ", (0, jsx_runtime_1.jsx)("strong", { children: "declare you've held your UK licence for the same number of years" }), " as your EU one."] }));
        };
        return _this;
    }
    DrivingExperienceQuestionWidget.prototype.render = function () {
        var title = this.renderHtml(this.getSetting(DrivingExperienceQuestionWidget.questionTitle, ""));
        var driverInteractionField = this.props.question.interactionField.split(".")[0];
        var oldDrivingLicenceType = this.bindFromField(driverInteractionField + ".licence.oldType");
        var newDrivingLicenceType = this.bindFromField(driverInteractionField + ".licence.type");
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "drivingExperience", children: title }), (oldDrivingLicenceType === "4" || oldDrivingLicenceType === "5") &&
                    (newDrivingLicenceType === "1" || newDrivingLicenceType === "2" || newDrivingLicenceType === "3") &&
                    this.renderLicenceChangeHeadsUpPopup(), this.renderInputField(), this.renderErrorMessage()] }));
    };
    DrivingExperienceQuestionWidget.prototype.renderErrorMessage = function () {
        var _a, _b;
        var validations = this.props.validations;
        if (!validations || Object.keys(validations).length === 0) {
            return null;
        }
        var fieldValidation = validations === null || validations === void 0 ? void 0 : validations[this.props.question.name];
        if (!fieldValidation || fieldValidation.valid) {
            return null;
        }
        var errorText = (_b = (_a = fieldValidation.errors) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : "Please answer this to carry on";
        return ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", role: "alert", children: errorText }));
    };
    DrivingExperienceQuestionWidget.inputDisabledSetting = "inputDisabled";
    DrivingExperienceQuestionWidget.questionTitle = "htmlLabel";
    return DrivingExperienceQuestionWidget;
}(FalconSelectQuestionWidgetBase_1.FalconSelectQuestionWidgetBase));
exports.DrivingExperienceQuestionWidget = DrivingExperienceQuestionWidget;
//# sourceMappingURL=DrivingExperienceQuestionWidget.js.map